import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { LocationEntity } from "./location.entity";
import { LocationService } from "./location.service";
import { LocationController } from "./location.controller";


@Module({
    imports: [
        TypeOrmModule.forFeature([LocationEntity]),
    ],
    controllers: [LocationController],
    providers: [LocationService, ApplicationExceptionHandler]
})
export class LocationModule {

}